// Seo.jsx — Phase 18 redesign pass.
//
// Thin wrapper around react-helmet-async so individual pages can set
// per-page title + description + canonical + og/twitter tags in one
// line without re-importing Helmet everywhere.
//
// Usage in a page:
//   <Seo title="Browse plugins" description="..." image="/og/browse.png" />
//
// App.js must wrap children in <HelmetProvider> for this to work.

import { Helmet } from "react-helmet-async";

const SITE_NAME = "Horizon AI";
const SITE_URL = "https://horizonaai.dev";
const DEFAULT_DESC = "Personal AI agent that runs on your machine. Bring your own keys. Desktop · Terminal CLI · Mobile.";
const DEFAULT_IMAGE = "/og-default.png";

export default function Seo({
  title,
  description = DEFAULT_DESC,
  image = DEFAULT_IMAGE,
  url,
  type = "website",
  noindex = false,
  keywords,
}) {
  const fullTitle = title ? `${title} · ${SITE_NAME}` : SITE_NAME;
  const canonical = url
    ? (url.startsWith("http") ? url : SITE_URL + url)
    : (typeof window !== "undefined" ? window.location.href : SITE_URL);
  const fullImage = image && image.startsWith("http") ? image : SITE_URL + image;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:image" content={fullImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
    </Helmet>
  );
}
